import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/components/login/login.component').then(m => m.LoginComponent)
  },
  // Registration disabled
  // {
  //   path: 'register',
  //   loadComponent: () => import('./features/auth/components/register/register.component').then(m => m.RegisterComponent)
  // },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'users',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_USERS')],
    loadComponent: () => import('./pages/users/users.component').then(m => m.UsersComponent)
  },
  {
    path: 'dmd',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_DMD')],
    loadComponent: () => import('./pages/dmd/dmd.component').then(m => m.DmdComponent)
  },
  {
    path: 'files',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_FILES')],
    loadComponent: () => import('./pages/files/files.component').then(m => m.FilesComponent)
  },
  {
    path: 'technicalType',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_FILES')],
    loadComponent: () => import('./pages/technical-type/technical-type.component').then(m => m.TechnicalTypeComponent)
  },
  {
    path: 'technical-type-backpropagation',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_FILES')],
    loadComponent: () => import('./pages/technical-type-backpropagation/technical-type-backpropagation.component').then(m => m.TechnicalTypeBackpropagationComponent)
  },
  {
    path: 'eds-extraction',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_DMD')],
    loadComponent: () => import('./pages/eds-extraction/eds-extraction.component').then(m => m.EdsExtractionComponent)
  },
  {
    path: 'dmd-backpropagation',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_DMD')],
    loadComponent: () => import('./pages/dmd-backpropagation/dmd-backpropagation.component').then(m => m.DmdBackpropagationComponent)
  },
  {
    path: 'survey-upload-cina-latam',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_SURVEY_UPLOAD')],
    loadComponent: () => import('./pages/survey-upload-cina-latam/survey-upload-cina-latam.component').then(m => m.SurveyUploadCinaLatamComponent)
  },
  {
    path: 'recovery-plan-reopen',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_RECOVERY_PLAN')],
    loadComponent: () => import('./pages/recovery-plan-reopen/recovery-plan-reopen.component').then(m => m.RecoveryPlanReopenComponent)
  },
  {
    path: 'yearly-tables',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_YEARLY_TABLES')],
    loadComponent: () => import('./pages/yearly-tables/yearly-tables.component').then(m => m.YearlyTablesComponent)
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
